module.exports = new __parcel__URL__("shop_machines_gasa_embassy_v2.f1a1da27.png").toString();